
import { TFunction } from 'i18next';
import * as Yup from 'yup';


export const stringRequired =(t: TFunction) => Yup.string().nullable()
    .required(t<string>("validation:string.required"));

export const stringRequiredAndMaxLength = (t: TFunction) => Yup.string()
    .required(t<string>("validation:string.required"))
    .max(100, t<string>("validation:string.maxlength", { size: 100 }));
